<template>
    <div>Cari Detay</div>
</template>

<script>
    export default {
        name: "caridetay"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sim/_/caridetay.vue